// GTM
import { useEffect } from 'react';
import { useConsent } from '../ConsentContext';

export const GTM = () => {
  const { consent } = useConsent();

  function deleteSaCookies() {
    Object.keys(
      document.cookie.split('; ').reduce(
        (acc, cookie) => {
          const [name] = cookie.split('=');
          if (name.startsWith('_ga')) {
            document.cookie = `${name}=; Max-Age=0; path=/; domain=${window.location.hostname};`;
          }
          return acc;
        },
        {} as Record<string, string>,
      ),
    );
  }

  useEffect(() => {
    if (consent === 'decline') {
      const script = document.getElementById('gmt-tag');
      deleteSaCookies();
      if (script) {
        script.remove();
      }
    } else {
      if (consent === 'accept' || document.cookie.indexOf(`cookies_accepted=`) === -1) {
        const script = document.createElement('script');
        script.id = 'gmt-tag';
        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${process.env.REACT_APP_GMT}');`;
        document.head.appendChild(script);
      }
    }
  }, [consent]);

  return (
    <>
      {consent && (
        <noscript>
          <img
            height="0"
            width="0"
            src={`https://www.googletagmanager.com/ns.html?id=${process.env.REACT_APP_GMT}`}
            style={{ display: 'none', visibility: 'hidden' }}
            alt="Facebook Pixel"
          />
        </noscript>
      )}
    </>
  );
};
